
if (!customElements.get("m-scrolling-promotion")) {
  class MScrollingPromotion extends HTMLElement {
    connectedCallback() {
      // Avoid rebuilding the marquee on reconnection.
      if (this.dataset.smoothMarqueeReady === "true") return;

      const existingTrack = this.querySelector(
        ":scope > .m-scrolling-promotion__track"
      );

      // Reuse an existing track if the element is reconnected.
      if (existingTrack) {
        this.classList.remove("m-scrolling-promotion--paused");
        this.dataset.smoothMarqueeReady = "true";
        return;
      }

      const promotion = this.querySelector(
        ":scope > .m-promotion"
      );

      if (!promotion || !promotion.children.length) return;

      this.dataset.smoothMarqueeReady = "true";

      // Save the original announcement items.
      const originalItems = Array.from(promotion.children).map(
        (item) => item.cloneNode(true)
      );

      // Create one lightweight animation track.
      const track = document.createElement("div");
      track.className = "m-scrolling-promotion__track";

      promotion.parentNode.insertBefore(track, promotion);
      track.appendChild(promotion);

      // Measure once. Only fill the group if it is
      // too short to cover the visible container.
      const containerWidth = this.clientWidth;
      const groupWidth = promotion.getBoundingClientRect().width;

      if (groupWidth > 0 && groupWidth < containerWidth) {
        const extraGroups = Math.min(
          10,
          Math.ceil(containerWidth / groupWidth) - 1
        );

        const fragment = document.createDocumentFragment();

        for (let group = 0; group < extraGroups; group++) {
          originalItems.forEach((item) => {
            const copy = item.cloneNode(true);

            copy.setAttribute("aria-hidden", "true");
            copy.inert = true;

            if (copy.id) copy.removeAttribute("id");

            copy.querySelectorAll("[id]").forEach((element) => {
              element.removeAttribute("id");
            });

            fragment.appendChild(copy);
          });
        }

        promotion.appendChild(fragment);
      }

      // Create exactly one duplicate sequence.
      const duplicate = promotion.cloneNode(true);

      duplicate.classList.add("m-promotion--clone");
      duplicate.setAttribute("aria-hidden", "true");
      duplicate.inert = true;

      if (duplicate.id) duplicate.removeAttribute("id");

      duplicate.querySelectorAll("[id]").forEach((element) => {
        element.removeAttribute("id");
      });

      track.appendChild(duplicate);

      // Never pause just because the cursor hovers over the bar.
      this.classList.remove("m-scrolling-promotion--paused");
    }
  }

  customElements.define(
    "m-scrolling-promotion",
    MScrollingPromotion
  );
}
